const state = {
    suppliers:[],
    typeSuppliers:[],
    loading: false,
};

export default state;